import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import withAuthLogin from 'hoc/withAuthLogin';
import styles from 'styles/Layout.module.scss';
import Header from './Header/Header';

const LandingLayout = ({ children }) => (
  <div className={styles.container}>
    <Header />
    <div className={classnames('container-xl', styles.contentBefore)}>
      {children}
    </div>
  </div>
);

LandingLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default withAuthLogin(LandingLayout);
